import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { UpdateService } from './shared/update-service/update.service';
import { PageComponent } from './core/layout/page.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [PageComponent]
})
export class AppComponent implements OnInit {
    private router = inject(Router);
    private updates = inject(UpdateService);
    private titleService = inject(Title);
    private activatedRoute = inject(ActivatedRoute);

    ngOnInit() {
        const appTitle = this.titleService.getTitle();
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    let child = this.activatedRoute.firstChild;
                    while (child && child.firstChild) {
                        child = child.firstChild;
                    }
                    if (child && child.snapshot.data['title']) {
                        return child.snapshot.data['title'];
                    }
                    return appTitle;
                })
            )
            .subscribe((ttl: string) => {
                this.titleService.setTitle(ttl);
            });
        this.updates.checkForUpdates();
    }
}
